// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'UICo... Remove this comment to see the full error message
import { SimpleDate } from 'UIComponents/core/SimpleDate';
export const timestampToSimpleDate = timestamp => {
  if (!timestamp) return null;
  const convertedDate = new Date(timestamp);
  const date = convertedDate.getDate();
  const month = convertedDate.getMonth();
  const year = convertedDate.getFullYear();
  return new SimpleDate(year, month, date);
};